export const connectionYaml = () => `connectors:
  - id: 
    providerId: 
    name: 
    description:
    options:
      - key: OPTION_KEY1
        value: |-
          {{ env.__HSS_OPTION_VALUE1 }}
        name: Option Name 1
        description:
        # TEXT|BOOLEAN|NUMBER|DATETIME
        displayType: TEXT`;
